import { paths } from 'src/routes/paths';

import type { GlobalSearchItem } from './searchTypes';

// ----------------------------------------------------------------------
// Route-first command palette items (aligned with src/routes/sections/*).

export const searchItems: GlobalSearchItem[] = [
  // {
  //   id: 'dashboard',
  //   title: 'Dashboard',
  //   subtitle: 'Home overview',
  //   breadcrumb: ['Dashboard'],
  //   keywords: ['home', 'overview', 'summary', 'main'],
  //   type: 'route',
  //   route: paths.dashboard.root,
  //   category: 'Dashboard',
  //   weight: 9,
  // },
  {
    id: 'getting-started',
    title: 'Getting Started',
    subtitle: 'Onboarding and setup',
    breadcrumb: ['Getting Started'],
    keywords: ['onboarding', 'setup', 'start', 'welcome', 'guide', 'tutorial'],
    type: 'route',
    route: paths.gettingStarted.root,
    category: 'Getting Started',
    weight: 8,
  },

  // Jobs
  {
    id: 'jobs-root',
    title: 'Jobs',
    subtitle: 'All jobs list',
    breadcrumb: ['Jobs'],
    keywords: ['roles', 'openings', 'requisitions', 'positions', 'listings', 'vacancies'],
    type: 'route',
    route: paths.jobs.root,
    category: 'Jobs',
    weight: 10,
  },
  // {
  //   id: 'jobs-job-details',
  //   title: 'Job details',
  //   subtitle: 'Edit job description and settings',
  //   breadcrumb: ['Jobs', 'Job details'],
  //   keywords: ['jd', 'description', 'posting', 'role', 'edit job', 'job editor'],
  //   type: 'route',
  //   route: paths.jobs.jobDetails,
  //   category: 'Jobs',
  //   subCategory: 'Editor',
  //   weight: 9,
  // },
  // {
  //   id: 'jobs-dashboard',
  //   title: 'Job dashboard',
  //   subtitle: 'Metrics for the selected job',
  //   breadcrumb: ['Jobs', 'Dashboard'],
  //   keywords: ['analytics', 'stats', 'metrics', 'job dashboard'],
  //   type: 'route',
  //   route: paths.jobs.dashboard,
  //   category: 'Jobs',
  //   subCategory: 'Dashboard',
  //   weight: 7,
  // },
  // {
  //   id: 'jobs-candidates',
  //   title: 'Job candidates',
  //   subtitle: 'Applicants for the current job',
  //   breadcrumb: ['Jobs', 'Candidates'],
  //   keywords: ['applicants', 'pipeline', 'job applicants', 'per job'],
  //   type: 'route',
  //   route: paths.jobs.candidates,
  //   category: 'Jobs',
  //   subCategory: 'Candidates',
  //   weight: 10,
  // },
  // {
  //   id: 'jobs-workflow',
  //   title: 'Workflow',
  //   subtitle: 'Hiring workflow and stages',
  //   breadcrumb: ['Jobs', 'Workflow'],
  //   keywords: ['stages', 'pipeline', 'process', 'automation', 'hiring flow'],
  //   type: 'route',
  //   route: paths.jobs.workflow,
  //   category: 'Jobs',
  //   subCategory: 'Workflow',
  //   weight: 8,
  // },
  // {
  //   id: 'jobs-interview-hub',
  //   title: 'Interview hub',
  //   subtitle: 'Interview overview and access',
  //   breadcrumb: ['Jobs', 'Interview hub'],
  //   keywords: ['ai interview', 'screening', 'hub', 'interviews'],
  //   type: 'route',
  //   route: paths.jobs.interviewHub,
  //   category: 'Jobs',
  //   subCategory: 'Interviews',
  //   weight: 9,
  // },
  // {
  //   id: 'jobs-interview-agenda',
  //   title: 'Interview agenda',
  //   subtitle: 'Schedule and agenda',
  //   breadcrumb: ['Jobs', 'Interview agenda'],
  //   keywords: ['calendar', 'schedule', 'agenda', 'meetings'],
  //   type: 'route',
  //   route: paths.jobs.interviewAgenda,
  //   category: 'Jobs',
  //   subCategory: 'Interviews',
  //   weight: 8,
  // },
  // {
  //   id: 'jobs-interview-evaluation',
  //   title: 'Interview evaluation',
  //   subtitle: 'Score and feedback',
  //   breadcrumb: ['Jobs', 'Interview evaluation'],
  //   keywords: ['eval', 'evaluation', 'feedback', 'score', 'rubric', 'assessment'],
  //   type: 'route',
  //   route: paths.jobs.interviewEvaluation,
  //   category: 'Jobs',
  //   subCategory: 'Interviews',
  //   weight: 10,
  // },
  // {
  //   id: 'jobs-create-job',
  //   title: 'Create job (from jobs)',
  //   subtitle: 'New job inside jobs area',
  //   breadcrumb: ['Jobs', 'Create job'],
  //   keywords: ['new job', 'add job', 'post job'],
  //   type: 'route',
  //   route: paths.jobs.createJob,
  //   category: 'Jobs',
  //   subCategory: 'Create',
  //   weight: 9,
  // },

  {
    id: 'create-job-standalone',
    title: 'Create job',
    subtitle: 'Standalone job creation flow',
    breadcrumb: ['Create job'],
    keywords: ['new job', 'add job', 'post job', 'job wizard', 'opening'],
    type: 'route',
    route: paths.createJob.root,
    category: 'Jobs',
    subCategory: 'Create',
    weight: 9,
  },

  // Global candidates
  {
    id: 'candidates-root',
    title: 'Candidates',
    subtitle: 'All candidates',
    breadcrumb: ['Candidates'],
    keywords: ['talent', 'applicants', 'profiles', 'database'],
    type: 'route',
    route: paths.candidates.root,
    category: 'Candidates',
    weight: 10,
  },
  // {
  //   id: 'candidates-details',
  //   title: 'Candidate details (legacy)',
  //   subtitle: 'Classic candidate profile',
  //   breadcrumb: ['Candidates', 'Details'],
  //   keywords: ['profile', 'legacy', 'detail view'],
  //   type: 'route',
  //   route: `${paths.candidates.root}/details`,
  //   category: 'Candidates',
  //   subCategory: 'Profile',
  //   weight: 6,
  // },
  // {
  //   id: 'candidates-new-details',
  //   title: 'Candidate profile',
  //   subtitle: 'New candidate detail experience',
  //   breadcrumb: ['Candidates', 'Profile'],
  //   keywords: ['profile', 'resume', 'cv', 'new detail', 'candidate page'],
  //   type: 'route',
  //   route: `${paths.candidates.root}/new-details`,
  //   category: 'Candidates',
  //   subCategory: 'Profile',
  //   weight: 9,
  // },

  // Organization settings — include umbrella keywords on each leaf for fuzzy recall
  {
    id: 'org-settings-root',
    title: 'Organization settings',
    subtitle: 'Workspace configuration (opens basic info)',
    breadcrumb: ['Organization', 'Settings'],
    keywords: [
      'settings',
      'org',
      'organization',
      'workspace',
      'company',
      'embed',
      'job board',
      'billing',
      'members',
      'invitations',
      'invite',
      'knowledge base',
      'kb',
      'ai persona',
      'interviewer',
      'email templates',
      'notifications',
      'agent',
      'subscription'
    ],
    type: 'route',
    route: paths.orgSettings.root,
    category: 'Organization',
    subCategory: 'Settings',
    weight: 8,
  },
  {
    id: 'org-settings-info',
    title: 'Basic information',
    subtitle: 'Organization name, logo, and details',
    breadcrumb: ['Organization', 'Settings', 'Basic info'],
    keywords: [
      'settings',
      'org',
      'organization',
      'info',
      'details',
      'logo',
      'profile',
      'workspace',
    ],
    type: 'route',
    route: paths.orgSettings.info,
    category: 'Organization',
    subCategory: 'Settings',
    weight: 9,
  },
  {
    id: 'org-settings-job-board-embed',
    title: 'Job board embed',
    subtitle: 'Show your open jobs on your own website',
    breadcrumb: ['Organization', 'Settings', 'Job board embed'],
    keywords: [
      'settings',
      'embed',
      'job board',
      'widget',
      'website',
      'careers page',
      'snippet',
      'code',
    ],
    type: 'route',
    route: paths.orgSettings.jobBoardEmbed,
    category: 'Organization',
    subCategory: 'Settings',
    weight: 7,
  },
  {
    id: 'org-settings-billing',
    title: 'Billing & plan',
    subtitle: 'Subscription and invoices',
    breadcrumb: ['Organization', 'Settings', 'Billing'],
    keywords: [
      'settings',
      'billing',
      'subscription',
      'plan',
      'stripe',
      'invoice',
      'payment',
      'upgrade',
    ],
    type: 'route',
    route: paths.orgSettings.billing,
    category: 'Organization',
    subCategory: 'Settings',
    weight: 8,
  },
  {
    id: 'org-settings-members',
    title: 'Members',
    subtitle: 'Team and roles',
    breadcrumb: ['Organization', 'Settings', 'Members'],
    keywords: ['settings', 'members', 'team', 'users', 'roles', 'permissions', 'staff'],
    type: 'route',
    route: paths.orgSettings.members,
    category: 'Organization',
    subCategory: 'Settings',
    weight: 8,
  },
  {
    id: 'org-settings-invitations',
    title: 'Invitations',
    subtitle: 'Pending and sent invites',
    breadcrumb: ['Organization', 'Settings', 'Invitations'],
    keywords: ['settings', 'invite', 'invitations', 'pending', 'email invite', 'team'],
    type: 'route',
    route: paths.orgSettings.invitations,
    category: 'Organization',
    subCategory: 'Settings',
    weight: 7,
  },
  {
    id: 'org-settings-knowledge-base',
    title: 'AI knowledge base',
    subtitle: 'Documents for AI context',
    breadcrumb: ['Organization', 'Settings', 'Knowledge base'],
    keywords: ['settings', 'kb', 'knowledge', 'documents', 'rag', 'ai', 'context'],
    type: 'route',
    route: paths.orgSettings.knowledgeBase,
    category: 'Organization',
    subCategory: 'Settings',
    weight: 7,
  },
  {
    id: 'org-settings-ai-persona',
    title: 'AI interviewer persona',
    subtitle: 'Tone and style for AI interviews',
    breadcrumb: ['Organization', 'Settings', 'AI persona'],
    keywords: ['settings', 'persona', 'ai', 'interviewer', 'tone', 'voice', 'character', 'agent'],
    type: 'route',
    route: paths.orgSettings.aiPersona,
    category: 'Organization',
    subCategory: 'Settings',
    weight: 7,
  },
  {
    id: 'org-settings-email-templates',
    title: 'Email templates',
    subtitle: 'Notification emails',
    breadcrumb: ['Organization', 'Settings', 'Notifications', 'Email templates'],
    keywords: [
      'settings',
      'email',
      'templates',
      'notifications',
      'messages',
      'communication',
      'smtp',
    ],
    type: 'route',
    route: paths.orgSettings.notifications.emailTemplates,
    category: 'Organization',
    subCategory: 'Settings',
    weight: 7,
  },

  // Billing callbacks (Stripe return URLs)
  // {
  //   id: 'billing-success',
  //   title: 'Billing success',
  //   subtitle: 'Payment completed',
  //   breadcrumb: ['Billing'],
  //   keywords: ['stripe', 'payment', 'success', 'checkout', 'paid'],
  //   type: 'route',
  //   route: paths.billing.success,
  //   category: 'Billing',
  //   weight: 5,
  // },
  // {
  //   id: 'billing-portal-return',
  //   title: 'Billing portal return',
  //   subtitle: 'Returned from customer portal',
  //   breadcrumb: ['Billing'],
  //   keywords: ['stripe', 'portal', 'subscription', 'manage billing'],
  //   type: 'route',
  //   route: paths.billing.portalReturn,
  //   category: 'Billing',
  //   weight: 5,
  // },
  // {
  //   id: 'org-billing-success',
  //   title: 'Billing success (org URL)',
  //   subtitle: 'Stripe success redirect under organization settings',
  //   breadcrumb: ['Organization', 'Billing'],
  //   keywords: ['stripe', 'payment', 'success', 'checkout'],
  //   type: 'route',
  //   route: `${paths.orgSettings.billing}/success`,
  //   category: 'Billing',
  //   weight: 4,
  // },
  // {
  //   id: 'org-billing-portal-return',
  //   title: 'Billing portal return (org URL)',
  //   subtitle: 'Stripe portal return under organization settings',
  //   breadcrumb: ['Organization', 'Billing'],
  //   keywords: ['stripe', 'portal', 'subscription'],
  //   type: 'route',
  //   route: `${paths.orgSettings.billing}/portal-return`,
  //   category: 'Billing',
  //   weight: 4,
  // },

  {
    id: 'events-trial',
    title: 'Events trial',
    subtitle: 'Trial landing page',
    breadcrumb: ['Events'],
    keywords: ['trial', 'demo', 'event', 'landing', 'public'],
    type: 'route',
    route: paths.eventsTrial,
    category: 'Marketing',
    weight: 6,
  },
];
